import { Injectable } from '@angular/core'
import { Converter, ConverterService, PRODUCT_NORMALIZER } from '@spartacus/core'
import { Wishlist } from '../../models'

@Injectable({
  providedIn: 'root'
})
export class MbWishlistNormalizer implements Converter<Wishlist, Wishlist> {

  constructor (protected converterService: ConverterService) { }

  convert (source: Wishlist, target?: Wishlist) {
    if (target === undefined) {
      target = { ...source } as Wishlist
    }
    if (source.entries) {
      target.entries = source.entries.map(entry => this.convertMbWishlistEntry(entry))
    }
    return target
  }

  private convertMbWishlistEntry (source?: any) {
    return {
      ...source,
      product: this.converterService.convert(source?.product, PRODUCT_NORMALIZER)
    }
  }
}
